// extracted by css-extract-rspack-plugin
export default {"row":"IssueRow-module__row__iTmG5od"};